import { render } from "./PictureTaker.vue?vue&type=template&id=0769546a&scoped=true"
import script from "./PictureTaker.vue?vue&type=script&lang=js"
export * from "./PictureTaker.vue?vue&type=script&lang=js"

import "./PictureTaker.vue?vue&type=style&index=0&id=0769546a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0769546a"]])

export default __exports__